import commonUtil from '@/utils/commonUtil';
/** 页面请求共通类 */
let dataAreaCommonUtils = {};

dataAreaCommonUtils.getFieldIcon = function(item) {
    switch (item.fieldTypeTrans) {
        case "1":
            return "number";
        case "2":
            return "datetime";
        case "3":
            return "string";
    }
    return "";
};

dataAreaCommonUtils.getColor = function(item) {
    switch (item.dataType) {
        case "1":
            return "#468cff";
        case "2":
            return "#64bd4f";
    }
    return "";
};

/** 需要传入数据区数据 */
dataAreaCommonUtils.getName = function(item) {
    let res = '';
    if (item.fieldNameRename === '' || item.fieldNameRename === undefined || item.fieldNameRename === null) {
        res += item.fieldData.fieldAlias;
        if (item.expression !== undefined && item.expression !== null && Object.keys(item.expression).length > 0) {
            res += '(' + item.expression.displayText + ')';
        }
    } else {
        res = item.fieldNameRename;
    }
    return res;
};

/**
 * 方法说明：获取右边栏Axis轴数据后，
 * 1.拼接getProcessData接口tbjFields参数(具体每条数据信息)
 * @param {Object} Axis 包含xAxis、yAxis、legend、filter右边栏数据
 * @return {Object}
 */
dataAreaCommonUtils.splicingFieldsArr = function(Axis) {
    let fieldsArr = [];
    let sort = [];
    // 返回Axis的key数组,Axis轴排序判断,(轴图：维度>图例>度量)
    let AxisArr = dataAreaCommonUtils.axisSort(Axis);
    for (let i = 0; i < AxisArr.length; i++) {
        // }
        // for (let i in Axis) {
        if (AxisArr[i] == "filter") {
            continue;
        }
        let obj = {};
        let child = Axis[AxisArr[i]].data;
        if (child.length > 0) {
            for (let j = 0; j < child.length; j++) {
                obj = {};
                obj.fieldName = child[j].fieldNameOrigin;
                obj.dataType = child[j].fieldData.dataType;
                obj.expression =
                    Object.keys(child[j].expression).length > 0
                        ? child[j].expression.value == "NO"
                            ? ""
                            : child[j].expression.value
                        : "";
                obj.fieldType = child[j].fieldData.fieldType;
                obj.fieldGroup = Axis[AxisArr[i]].key;
                obj.chartType = child[j].BLA;
                obj.alias = dataAreaCommonUtils.getName(child[j]);
                obj.name = "";
                obj.index = j;
                obj.dataFormatter = child[j].fieldData.hasOwnProperty("formatter")
                    ? child[j].fieldData.formatter
                    : "";
                if (child[j].order.value && child[j].order.value != "no") {
                    sort.push({
                        sortFieldName: child[j].fieldNameOrigin,
                        expression:
                            Object.keys(child[j].expression).length > 0
                                ? child[j].expression.value == "NO"
                                    ? ""
                                    : child[j].expression.value
                                : "",
                        sortType: child[j].order.value
                    });
                }
                fieldsArr.push(obj);
            }
        }
    }
    return {fieldsArr, sort};
};

/**
 * 方法说明：2.拼接getProcessData接口请求参数
 * @param {Object} Axis 包含xAxis、yAxis、legend、filter的右边栏数据
 * @param {String} sjjId 数据集id
 * @param {String} chartType 图形具体类型，例如：'bar'、'line'
 * @param {Number} limit 返回数据条数
 * @return {Object} 作为请求参数
 */
dataAreaCommonUtils.getAxisReq = function(Axis, sjjId, chartType, limit) {
    let obj = dataAreaCommonUtils.splicingFieldsArr(Axis);
    if (obj.fieldsArr.length == 0) {
        return;
    }
    let req = {
        tbjData: {
            sjjId: sjjId,
            tbjFields: obj.fieldsArr,
            sort: obj.sort,
            distinct: "",
            chartType: chartType, //图形类型对象中的type具体类型
            filterData: Axis.filter.data.length > 0 ? Axis.filter.data : [],
            limit: limit ? limit : "1000"
        }
    };
    return req;
};
/**
 * 给轴排序，作为拼接参数的遍历顺序
 * @param {Object} Axis 轴全部数据
 * @returns AxisArr数组，仅包含轴key的Name的数组
 */
dataAreaCommonUtils.axisSort = function(Axis) {
    let AxisArr = Object.keys(Axis);
    if (AxisArr.indexOf("yAxis") != -1 && AxisArr.indexOf("legend") != -1) {
        return (AxisArr = ["xAxis", "legend", "yAxis", "filter"]);
    }
    return AxisArr;
};
// 3/ 优化**指定**获取一个轴的数据数组
dataAreaCommonUtils.getSpecifyAxisKeysName = function(dataArray, metaArray, Axis) {
    // 单一轴数据对象
    let singleAxisKeysName = [];
    let singleAxisData = [];
    for (let i in metaArray) {
        if (Axis == metaArray[i].fieldGroup) {
            singleAxisData.push({
                name: metaArray[i].fieldName,
                index: metaArray[i].index,
                alias: metaArray[i].alias
            });
        }
    }
    // 排序
    singleAxisData.sort(function(a, b) {
        return a.index - b.index;
    });
    for (let j = 0; j < singleAxisData.length; j++) {
        singleAxisKeysName.push(singleAxisData[j].name);
    }
    return singleAxisKeysName;
};
/**
 * 处理右边栏的数据
 * @param {Object} Axis 右边栏轴数据
 * @returns 数组结构，右边栏非数值格式的，选中的key和fieldData
 */
dataAreaCommonUtils.processAxisData = function(Axis) {
    let singleAxisFieldData = [];
    let axisFieldData = [];
    let flag = false;
    for (let i in Axis) {
        flag = false;
        let data = Axis[i].data;
        singleAxisFieldData = [];
        for (let j = 0; j < data.length; j++) {
            if (commonUtil.getFieldType(data[j].fieldData) != "1") {
                let obj = {};
                obj.key = data[j].fieldData.fieldName;
                obj.value = data[j].fieldData;
                singleAxisFieldData.push(obj);
                if (j == data.length - 1) {
                    flag = true;
                }
            }
            if (flag) {
                axisFieldData.push(singleAxisFieldData);
            }
        }
    }
    return axisFieldData;
};
export default dataAreaCommonUtils;
